import React from 'react';
import './_styles.scss';
import { UserPermissions } from '../../../../definitions';
import { securityService } from '../../../../_global/services';

interface FaqCardProps {
  data?: any;
}

export default function FaqCard({ data }: FaqCardProps) {
  const { order, question, is_active } = data;

  return securityService.checkRoleAccess(UserPermissions.viewFaqs) ? (
    <div className='user-card'>
      <div className='full-name'>{`${question}`}</div>
      <div className='status'>{`No. ${order} : ${
        is_active ? 'Active' : 'Inactive'
      }`}</div>
    </div>
  ) : (
    <div></div>
  );
}
